var Kt = Object.defineProperty;
var Zt = (e, r, t) => r in e ? Kt(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t;
var B = (e, r, t) => (Zt(e, typeof r != "symbol" ? r + "" : r, t), t);
import * as ae from "react";
import st, { forwardRef as Fe, useContext as ct, Children as Me, useState as Be, useRef as zr, Fragment as Xt, useEffect as Qt } from "react";
import { css as z } from "@emotion/react";
import { globalColor as Q, illaPrefix as ee, applyBoxStyle as _r, deleteCssProps as er } from "@illa-design/theme";
import { mergedToString as je } from "@illa-design/system";
import { CopyIcon as ft, SuccessCircleIcon as ut } from "@illa-design/icon";
import { Trigger as rr } from "@illa-design/trigger";
import { ConfigProviderContext as en, def as lt } from "@illa-design/config-provider";
import rn from "react-use-measure";
var vr = { exports: {} }, $e = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ur;
function tn() {
  if (Ur)
    return $e;
  Ur = 1;
  var e = st, r = Symbol.for("react.element"), t = Symbol.for("react.fragment"), o = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, i = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(f, d, h) {
    var p, v = {}, b = null, _ = null;
    h !== void 0 && (b = "" + h), d.key !== void 0 && (b = "" + d.key), d.ref !== void 0 && (_ = d.ref);
    for (p in d)
      o.call(d, p) && !i.hasOwnProperty(p) && (v[p] = d[p]);
    if (f && f.defaultProps)
      for (p in d = f.defaultProps, d)
        v[p] === void 0 && (v[p] = d[p]);
    return { $$typeof: r, type: f, key: b, ref: _, props: v, _owner: a.current };
  }
  return $e.Fragment = t, $e.jsx = s, $e.jsxs = s, $e;
}
var Ae = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Br;
function nn() {
  return Br || (Br = 1, process.env.NODE_ENV !== "production" && function() {
    var e = st, r = Symbol.for("react.element"), t = Symbol.for("react.portal"), o = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), f = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), h = Symbol.for("react.suspense"), p = Symbol.for("react.suspense_list"), v = Symbol.for("react.memo"), b = Symbol.for("react.lazy"), _ = Symbol.for("react.offscreen"), C = Symbol.iterator, m = "@@iterator";
    function k(n) {
      if (n === null || typeof n != "object")
        return null;
      var c = C && n[C] || n[m];
      return typeof c == "function" ? c : null;
    }
    var x = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function E(n) {
      {
        for (var c = arguments.length, l = new Array(c > 1 ? c - 1 : 0), g = 1; g < c; g++)
          l[g - 1] = arguments[g];
        $("error", n, l);
      }
    }
    function $(n, c, l) {
      {
        var g = x.ReactDebugCurrentFrame, R = g.getStackAddendum();
        R !== "" && (c += "%s", l = l.concat([R]));
        var D = l.map(function(w) {
          return String(w);
        });
        D.unshift("Warning: " + c), Function.prototype.apply.call(console[n], console, D);
      }
    }
    var I = !1, u = !1, F = !1, T = !1, fe = !1, ue;
    ue = Symbol.for("react.module.reference");
    function le(n) {
      return !!(typeof n == "string" || typeof n == "function" || n === o || n === i || fe || n === a || n === h || n === p || T || n === _ || I || u || F || typeof n == "object" && n !== null && (n.$$typeof === b || n.$$typeof === v || n.$$typeof === s || n.$$typeof === f || n.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      n.$$typeof === ue || n.getModuleId !== void 0));
    }
    function Se(n, c, l) {
      var g = n.displayName;
      if (g)
        return g;
      var R = c.displayName || c.name || "";
      return R !== "" ? l + "(" + R + ")" : l;
    }
    function de(n) {
      return n.displayName || "Context";
    }
    function G(n) {
      if (n == null)
        return null;
      if (typeof n.tag == "number" && E("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof n == "function")
        return n.displayName || n.name || null;
      if (typeof n == "string")
        return n;
      switch (n) {
        case o:
          return "Fragment";
        case t:
          return "Portal";
        case i:
          return "Profiler";
        case a:
          return "StrictMode";
        case h:
          return "Suspense";
        case p:
          return "SuspenseList";
      }
      if (typeof n == "object")
        switch (n.$$typeof) {
          case f:
            var c = n;
            return de(c) + ".Consumer";
          case s:
            var l = n;
            return de(l._context) + ".Provider";
          case d:
            return Se(n, n.render, "ForwardRef");
          case v:
            var g = n.displayName || null;
            return g !== null ? g : G(n.type) || "Memo";
          case b: {
            var R = n, D = R._payload, w = R._init;
            try {
              return G(w(D));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var Z = Object.assign, ne = 0, pe, he, ie, ve, se, Ve, Ye;
    function We() {
    }
    We.__reactDisabledLog = !0;
    function ir() {
      {
        if (ne === 0) {
          pe = console.log, he = console.info, ie = console.warn, ve = console.error, se = console.group, Ve = console.groupCollapsed, Ye = console.groupEnd;
          var n = {
            configurable: !0,
            enumerable: !0,
            value: We,
            writable: !0
          };
          Object.defineProperties(console, {
            info: n,
            log: n,
            warn: n,
            error: n,
            group: n,
            groupCollapsed: n,
            groupEnd: n
          });
        }
        ne++;
      }
    }
    function sr() {
      {
        if (ne--, ne === 0) {
          var n = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: Z({}, n, {
              value: pe
            }),
            info: Z({}, n, {
              value: he
            }),
            warn: Z({}, n, {
              value: ie
            }),
            error: Z({}, n, {
              value: ve
            }),
            group: Z({}, n, {
              value: se
            }),
            groupCollapsed: Z({}, n, {
              value: Ve
            }),
            groupEnd: Z({}, n, {
              value: Ye
            })
          });
        }
        ne < 0 && E("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var we = x.ReactCurrentDispatcher, Te;
    function ye(n, c, l) {
      {
        if (Te === void 0)
          try {
            throw Error();
          } catch (R) {
            var g = R.stack.trim().match(/\n( *(at )?)/);
            Te = g && g[1] || "";
          }
        return `
` + Te + n;
      }
    }
    var Re = !1, me;
    {
      var cr = typeof WeakMap == "function" ? WeakMap : Map;
      me = new cr();
    }
    function y(n, c) {
      if (!n || Re)
        return "";
      {
        var l = me.get(n);
        if (l !== void 0)
          return l;
      }
      var g;
      Re = !0;
      var R = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var D;
      D = we.current, we.current = null, ir();
      try {
        if (c) {
          var w = function() {
            throw Error();
          };
          if (Object.defineProperty(w.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(w, []);
            } catch (oe) {
              g = oe;
            }
            Reflect.construct(n, [], w);
          } else {
            try {
              w.call();
            } catch (oe) {
              g = oe;
            }
            n.call(w.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (oe) {
            g = oe;
          }
          n();
        }
      } catch (oe) {
        if (oe && g && typeof oe.stack == "string") {
          for (var S = oe.stack.split(`
`), U = g.stack.split(`
`), M = S.length - 1, j = U.length - 1; M >= 1 && j >= 0 && S[M] !== U[j]; )
            j--;
          for (; M >= 1 && j >= 0; M--, j--)
            if (S[M] !== U[j]) {
              if (M !== 1 || j !== 1)
                do
                  if (M--, j--, j < 0 || S[M] !== U[j]) {
                    var J = `
` + S[M].replace(" at new ", " at ");
                    return n.displayName && J.includes("<anonymous>") && (J = J.replace("<anonymous>", n.displayName)), typeof n == "function" && me.set(n, J), J;
                  }
                while (M >= 1 && j >= 0);
              break;
            }
        }
      } finally {
        Re = !1, we.current = D, sr(), Error.prepareStackTrace = R;
      }
      var Ee = n ? n.displayName || n.name : "", Wr = Ee ? ye(Ee) : "";
      return typeof n == "function" && me.set(n, Wr), Wr;
    }
    function Oe(n, c, l) {
      return y(n, !1);
    }
    function ge(n) {
      var c = n.prototype;
      return !!(c && c.isReactComponent);
    }
    function ce(n, c, l) {
      if (n == null)
        return "";
      if (typeof n == "function")
        return y(n, ge(n));
      if (typeof n == "string")
        return ye(n);
      switch (n) {
        case h:
          return ye("Suspense");
        case p:
          return ye("SuspenseList");
      }
      if (typeof n == "object")
        switch (n.$$typeof) {
          case d:
            return Oe(n.render);
          case v:
            return ce(n.type, c, l);
          case b: {
            var g = n, R = g._payload, D = g._init;
            try {
              return ce(D(R), c, l);
            } catch {
            }
          }
        }
      return "";
    }
    var ze = Object.prototype.hasOwnProperty, $r = {}, Ar = x.ReactDebugCurrentFrame;
    function Ue(n) {
      if (n) {
        var c = n._owner, l = ce(n.type, n._source, c ? c.type : null);
        Ar.setExtraStackFrame(l);
      } else
        Ar.setExtraStackFrame(null);
    }
    function $t(n, c, l, g, R) {
      {
        var D = Function.call.bind(ze);
        for (var w in n)
          if (D(n, w)) {
            var S = void 0;
            try {
              if (typeof n[w] != "function") {
                var U = Error((g || "React class") + ": " + l + " type `" + w + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof n[w] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw U.name = "Invariant Violation", U;
              }
              S = n[w](c, w, g, l, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (M) {
              S = M;
            }
            S && !(S instanceof Error) && (Ue(R), E("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", g || "React class", l, w, typeof S), Ue(null)), S instanceof Error && !(S.message in $r) && ($r[S.message] = !0, Ue(R), E("Failed %s type: %s", l, S.message), Ue(null));
          }
      }
    }
    var At = Array.isArray;
    function fr(n) {
      return At(n);
    }
    function Nt(n) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, l = c && n[Symbol.toStringTag] || n.constructor.name || "Object";
        return l;
      }
    }
    function kt(n) {
      try {
        return Nr(n), !1;
      } catch {
        return !0;
      }
    }
    function Nr(n) {
      return "" + n;
    }
    function kr(n) {
      if (kt(n))
        return E("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", Nt(n)), Nr(n);
    }
    var Pe = x.ReactCurrentOwner, It = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, Ir, Dr, ur;
    ur = {};
    function Dt(n) {
      if (ze.call(n, "ref")) {
        var c = Object.getOwnPropertyDescriptor(n, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return n.ref !== void 0;
    }
    function Ft(n) {
      if (ze.call(n, "key")) {
        var c = Object.getOwnPropertyDescriptor(n, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return n.key !== void 0;
    }
    function Mt(n, c) {
      if (typeof n.ref == "string" && Pe.current && c && Pe.current.stateNode !== c) {
        var l = G(Pe.current.type);
        ur[l] || (E('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', G(Pe.current.type), n.ref), ur[l] = !0);
      }
    }
    function jt(n, c) {
      {
        var l = function() {
          Ir || (Ir = !0, E("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        l.isReactWarning = !0, Object.defineProperty(n, "key", {
          get: l,
          configurable: !0
        });
      }
    }
    function Lt(n, c) {
      {
        var l = function() {
          Dr || (Dr = !0, E("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        l.isReactWarning = !0, Object.defineProperty(n, "ref", {
          get: l,
          configurable: !0
        });
      }
    }
    var Vt = function(n, c, l, g, R, D, w) {
      var S = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: r,
        // Built-in properties that belong on the element
        type: n,
        key: c,
        ref: l,
        props: w,
        // Record the component responsible for creating this element.
        _owner: D
      };
      return S._store = {}, Object.defineProperty(S._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(S, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: g
      }), Object.defineProperty(S, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: R
      }), Object.freeze && (Object.freeze(S.props), Object.freeze(S)), S;
    };
    function Yt(n, c, l, g, R) {
      {
        var D, w = {}, S = null, U = null;
        l !== void 0 && (kr(l), S = "" + l), Ft(c) && (kr(c.key), S = "" + c.key), Dt(c) && (U = c.ref, Mt(c, R));
        for (D in c)
          ze.call(c, D) && !It.hasOwnProperty(D) && (w[D] = c[D]);
        if (n && n.defaultProps) {
          var M = n.defaultProps;
          for (D in M)
            w[D] === void 0 && (w[D] = M[D]);
        }
        if (S || U) {
          var j = typeof n == "function" ? n.displayName || n.name || "Unknown" : n;
          S && jt(w, j), U && Lt(w, j);
        }
        return Vt(n, S, U, R, g, Pe.current, w);
      }
    }
    var lr = x.ReactCurrentOwner, Fr = x.ReactDebugCurrentFrame;
    function be(n) {
      if (n) {
        var c = n._owner, l = ce(n.type, n._source, c ? c.type : null);
        Fr.setExtraStackFrame(l);
      } else
        Fr.setExtraStackFrame(null);
    }
    var dr;
    dr = !1;
    function pr(n) {
      return typeof n == "object" && n !== null && n.$$typeof === r;
    }
    function Mr() {
      {
        if (lr.current) {
          var n = G(lr.current.type);
          if (n)
            return `

Check the render method of \`` + n + "`.";
        }
        return "";
      }
    }
    function Wt(n) {
      {
        if (n !== void 0) {
          var c = n.fileName.replace(/^.*[\\\/]/, ""), l = n.lineNumber;
          return `

Check your code at ` + c + ":" + l + ".";
        }
        return "";
      }
    }
    var jr = {};
    function zt(n) {
      {
        var c = Mr();
        if (!c) {
          var l = typeof n == "string" ? n : n.displayName || n.name;
          l && (c = `

Check the top-level render call using <` + l + ">.");
        }
        return c;
      }
    }
    function Lr(n, c) {
      {
        if (!n._store || n._store.validated || n.key != null)
          return;
        n._store.validated = !0;
        var l = zt(c);
        if (jr[l])
          return;
        jr[l] = !0;
        var g = "";
        n && n._owner && n._owner !== lr.current && (g = " It was passed a child from " + G(n._owner.type) + "."), be(n), E('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', l, g), be(null);
      }
    }
    function Vr(n, c) {
      {
        if (typeof n != "object")
          return;
        if (fr(n))
          for (var l = 0; l < n.length; l++) {
            var g = n[l];
            pr(g) && Lr(g, c);
          }
        else if (pr(n))
          n._store && (n._store.validated = !0);
        else if (n) {
          var R = k(n);
          if (typeof R == "function" && R !== n.entries)
            for (var D = R.call(n), w; !(w = D.next()).done; )
              pr(w.value) && Lr(w.value, c);
        }
      }
    }
    function Ut(n) {
      {
        var c = n.type;
        if (c == null || typeof c == "string")
          return;
        var l;
        if (typeof c == "function")
          l = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === v))
          l = c.propTypes;
        else
          return;
        if (l) {
          var g = G(c);
          $t(l, n.props, "prop", g, n);
        } else if (c.PropTypes !== void 0 && !dr) {
          dr = !0;
          var R = G(c);
          E("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", R || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && E("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Bt(n) {
      {
        for (var c = Object.keys(n.props), l = 0; l < c.length; l++) {
          var g = c[l];
          if (g !== "children" && g !== "key") {
            be(n), E("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", g), be(null);
            break;
          }
        }
        n.ref !== null && (be(n), E("Invalid attribute `ref` supplied to `React.Fragment`."), be(null));
      }
    }
    function Yr(n, c, l, g, R, D) {
      {
        var w = le(n);
        if (!w) {
          var S = "";
          (n === void 0 || typeof n == "object" && n !== null && Object.keys(n).length === 0) && (S += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var U = Wt(R);
          U ? S += U : S += Mr();
          var M;
          n === null ? M = "null" : fr(n) ? M = "array" : n !== void 0 && n.$$typeof === r ? (M = "<" + (G(n.type) || "Unknown") + " />", S = " Did you accidentally export a JSX literal instead of a component?") : M = typeof n, E("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", M, S);
        }
        var j = Yt(n, c, l, R, D);
        if (j == null)
          return j;
        if (w) {
          var J = c.children;
          if (J !== void 0)
            if (g)
              if (fr(J)) {
                for (var Ee = 0; Ee < J.length; Ee++)
                  Vr(J[Ee], n);
                Object.freeze && Object.freeze(J);
              } else
                E("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Vr(J, n);
        }
        return n === o ? Bt(j) : Ut(j), j;
      }
    }
    function qt(n, c, l) {
      return Yr(n, c, l, !0);
    }
    function Gt(n, c, l) {
      return Yr(n, c, l, !1);
    }
    var Ht = Gt, Jt = qt;
    Ae.Fragment = o, Ae.jsx = Ht, Ae.jsxs = Jt;
  }()), Ae;
}
process.env.NODE_ENV === "production" ? vr.exports = tn() : vr.exports = nn();
var Ze = vr.exports;
function on(e) {
  if (e.sheet)
    return e.sheet;
  for (var r = 0; r < document.styleSheets.length; r++)
    if (document.styleSheets[r].ownerNode === e)
      return document.styleSheets[r];
}
function an(e) {
  var r = document.createElement("style");
  return r.setAttribute("data-emotion", e.key), e.nonce !== void 0 && r.setAttribute("nonce", e.nonce), r.appendChild(document.createTextNode("")), r.setAttribute("data-s", ""), r;
}
var sn = /* @__PURE__ */ function() {
  function e(t) {
    var o = this;
    this._insertTag = function(a) {
      var i;
      o.tags.length === 0 ? o.insertionPoint ? i = o.insertionPoint.nextSibling : o.prepend ? i = o.container.firstChild : i = o.before : i = o.tags[o.tags.length - 1].nextSibling, o.container.insertBefore(a, i), o.tags.push(a);
    }, this.isSpeedy = t.speedy === void 0 ? process.env.NODE_ENV === "production" : t.speedy, this.tags = [], this.ctr = 0, this.nonce = t.nonce, this.key = t.key, this.container = t.container, this.prepend = t.prepend, this.insertionPoint = t.insertionPoint, this.before = null;
  }
  var r = e.prototype;
  return r.hydrate = function(o) {
    o.forEach(this._insertTag);
  }, r.insert = function(o) {
    this.ctr % (this.isSpeedy ? 65e3 : 1) === 0 && this._insertTag(an(this));
    var a = this.tags[this.tags.length - 1];
    if (process.env.NODE_ENV !== "production") {
      var i = o.charCodeAt(0) === 64 && o.charCodeAt(1) === 105;
      i && this._alreadyInsertedOrderInsensitiveRule && console.error(`You're attempting to insert the following rule:
` + o + "\n\n`@import` rules must be before all other types of rules in a stylesheet but other rules have already been inserted. Please ensure that `@import` rules are before all other rules."), this._alreadyInsertedOrderInsensitiveRule = this._alreadyInsertedOrderInsensitiveRule || !i;
    }
    if (this.isSpeedy) {
      var s = on(a);
      try {
        s.insertRule(o, s.cssRules.length);
      } catch (f) {
        process.env.NODE_ENV !== "production" && !/:(-moz-placeholder|-moz-focus-inner|-moz-focusring|-ms-input-placeholder|-moz-read-write|-moz-read-only|-ms-clear|-ms-expand|-ms-reveal){/.test(o) && console.error('There was a problem inserting the following rule: "' + o + '"', f);
      }
    } else
      a.appendChild(document.createTextNode(o));
    this.ctr++;
  }, r.flush = function() {
    this.tags.forEach(function(o) {
      return o.parentNode && o.parentNode.removeChild(o);
    }), this.tags = [], this.ctr = 0, process.env.NODE_ENV !== "production" && (this._alreadyInsertedOrderInsensitiveRule = !1);
  }, e;
}(), W = "-ms-", Xe = "-moz-", O = "-webkit-", Cr = "comm", Sr = "rule", wr = "decl", cn = "@import", dt = "@keyframes", fn = "@layer", un = Math.abs, tr = String.fromCharCode, ln = Object.assign;
function dn(e, r) {
  return Y(e, 0) ^ 45 ? (((r << 2 ^ Y(e, 0)) << 2 ^ Y(e, 1)) << 2 ^ Y(e, 2)) << 2 ^ Y(e, 3) : 0;
}
function pt(e) {
  return e.trim();
}
function pn(e, r) {
  return (e = r.exec(e)) ? e[0] : e;
}
function P(e, r, t) {
  return e.replace(r, t);
}
function yr(e, r) {
  return e.indexOf(r);
}
function Y(e, r) {
  return e.charCodeAt(r) | 0;
}
function ke(e, r, t) {
  return e.slice(r, t);
}
function re(e) {
  return e.length;
}
function Tr(e) {
  return e.length;
}
function qe(e, r) {
  return r.push(e), e;
}
function hn(e, r) {
  return e.map(r).join("");
}
var nr = 1, _e = 1, ht = 0, q = 0, L = 0, Ce = "";
function or(e, r, t, o, a, i, s) {
  return { value: e, root: r, parent: t, type: o, props: a, children: i, line: nr, column: _e, length: s, return: "" };
}
function Ne(e, r) {
  return ln(or("", null, null, "", null, null, 0), e, { length: -e.length }, r);
}
function vn() {
  return L;
}
function yn() {
  return L = q > 0 ? Y(Ce, --q) : 0, _e--, L === 10 && (_e = 1, nr--), L;
}
function H() {
  return L = q < ht ? Y(Ce, q++) : 0, _e++, L === 10 && (_e = 1, nr++), L;
}
function te() {
  return Y(Ce, q);
}
function He() {
  return q;
}
function Le(e, r) {
  return ke(Ce, e, r);
}
function Ie(e) {
  switch (e) {
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    case 59:
    case 123:
    case 125:
      return 4;
    case 58:
      return 3;
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function vt(e) {
  return nr = _e = 1, ht = re(Ce = e), q = 0, [];
}
function yt(e) {
  return Ce = "", e;
}
function Je(e) {
  return pt(Le(q - 1, mr(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function mn(e) {
  for (; (L = te()) && L < 33; )
    H();
  return Ie(e) > 2 || Ie(L) > 3 ? "" : " ";
}
function gn(e, r) {
  for (; --r && H() && !(L < 48 || L > 102 || L > 57 && L < 65 || L > 70 && L < 97); )
    ;
  return Le(e, He() + (r < 6 && te() == 32 && H() == 32));
}
function mr(e) {
  for (; H(); )
    switch (L) {
      case e:
        return q;
      case 34:
      case 39:
        e !== 34 && e !== 39 && mr(L);
        break;
      case 40:
        e === 41 && mr(e);
        break;
      case 92:
        H();
        break;
    }
  return q;
}
function bn(e, r) {
  for (; H() && e + L !== 47 + 10; )
    if (e + L === 42 + 42 && te() === 47)
      break;
  return "/*" + Le(r, q - 1) + "*" + tr(e === 47 ? e : H());
}
function En(e) {
  for (; !Ie(te()); )
    H();
  return Le(e, q);
}
function xn(e) {
  return yt(Ke("", null, null, null, [""], e = vt(e), 0, [0], e));
}
function Ke(e, r, t, o, a, i, s, f, d) {
  for (var h = 0, p = 0, v = s, b = 0, _ = 0, C = 0, m = 1, k = 1, x = 1, E = 0, $ = "", I = a, u = i, F = o, T = $; k; )
    switch (C = E, E = H()) {
      case 40:
        if (C != 108 && Y(T, v - 1) == 58) {
          yr(T += P(Je(E), "&", "&\f"), "&\f") != -1 && (x = -1);
          break;
        }
      case 34:
      case 39:
      case 91:
        T += Je(E);
        break;
      case 9:
      case 10:
      case 13:
      case 32:
        T += mn(C);
        break;
      case 92:
        T += gn(He() - 1, 7);
        continue;
      case 47:
        switch (te()) {
          case 42:
          case 47:
            qe(_n(bn(H(), He()), r, t), d);
            break;
          default:
            T += "/";
        }
        break;
      case 123 * m:
        f[h++] = re(T) * x;
      case 125 * m:
      case 59:
      case 0:
        switch (E) {
          case 0:
          case 125:
            k = 0;
          case 59 + p:
            x == -1 && (T = P(T, /\f/g, "")), _ > 0 && re(T) - v && qe(_ > 32 ? Gr(T + ";", o, t, v - 1) : Gr(P(T, " ", "") + ";", o, t, v - 2), d);
            break;
          case 59:
            T += ";";
          default:
            if (qe(F = qr(T, r, t, h, p, a, f, $, I = [], u = [], v), i), E === 123)
              if (p === 0)
                Ke(T, r, F, F, I, i, v, f, u);
              else
                switch (b === 99 && Y(T, 3) === 110 ? 100 : b) {
                  case 100:
                  case 108:
                  case 109:
                  case 115:
                    Ke(e, F, F, o && qe(qr(e, F, F, 0, 0, a, f, $, a, I = [], v), u), a, u, v, f, o ? I : u);
                    break;
                  default:
                    Ke(T, F, F, F, [""], u, 0, f, u);
                }
        }
        h = p = _ = 0, m = x = 1, $ = T = "", v = s;
        break;
      case 58:
        v = 1 + re(T), _ = C;
      default:
        if (m < 1) {
          if (E == 123)
            --m;
          else if (E == 125 && m++ == 0 && yn() == 125)
            continue;
        }
        switch (T += tr(E), E * m) {
          case 38:
            x = p > 0 ? 1 : (T += "\f", -1);
            break;
          case 44:
            f[h++] = (re(T) - 1) * x, x = 1;
            break;
          case 64:
            te() === 45 && (T += Je(H())), b = te(), p = v = re($ = T += En(He())), E++;
            break;
          case 45:
            C === 45 && re(T) == 2 && (m = 0);
        }
    }
  return i;
}
function qr(e, r, t, o, a, i, s, f, d, h, p) {
  for (var v = a - 1, b = a === 0 ? i : [""], _ = Tr(b), C = 0, m = 0, k = 0; C < o; ++C)
    for (var x = 0, E = ke(e, v + 1, v = un(m = s[C])), $ = e; x < _; ++x)
      ($ = pt(m > 0 ? b[x] + " " + E : P(E, /&\f/g, b[x]))) && (d[k++] = $);
  return or(e, r, t, a === 0 ? Sr : f, d, h, p);
}
function _n(e, r, t) {
  return or(e, r, t, Cr, tr(vn()), ke(e, 2, -2), 0);
}
function Gr(e, r, t, o) {
  return or(e, r, t, wr, ke(e, 0, o), ke(e, o + 1, -1), o);
}
function xe(e, r) {
  for (var t = "", o = Tr(e), a = 0; a < o; a++)
    t += r(e[a], a, e, r) || "";
  return t;
}
function Cn(e, r, t, o) {
  switch (e.type) {
    case fn:
      if (e.children.length)
        break;
    case cn:
    case wr:
      return e.return = e.return || e.value;
    case Cr:
      return "";
    case dt:
      return e.return = e.value + "{" + xe(e.children, o) + "}";
    case Sr:
      e.value = e.props.join(",");
  }
  return re(t = xe(e.children, o)) ? e.return = e.value + "{" + t + "}" : "";
}
function Sn(e) {
  var r = Tr(e);
  return function(t, o, a, i) {
    for (var s = "", f = 0; f < r; f++)
      s += e[f](t, o, a, i) || "";
    return s;
  };
}
function wn(e) {
  return function(r) {
    r.root || (r = r.return) && e(r);
  };
}
function Tn(e) {
  var r = /* @__PURE__ */ Object.create(null);
  return function(t) {
    return r[t] === void 0 && (r[t] = e(t)), r[t];
  };
}
var Rn = function(r, t, o) {
  for (var a = 0, i = 0; a = i, i = te(), a === 38 && i === 12 && (t[o] = 1), !Ie(i); )
    H();
  return Le(r, q);
}, On = function(r, t) {
  var o = -1, a = 44;
  do
    switch (Ie(a)) {
      case 0:
        a === 38 && te() === 12 && (t[o] = 1), r[o] += Rn(q - 1, t, o);
        break;
      case 2:
        r[o] += Je(a);
        break;
      case 4:
        if (a === 44) {
          r[++o] = te() === 58 ? "&\f" : "", t[o] = r[o].length;
          break;
        }
      default:
        r[o] += tr(a);
    }
  while (a = H());
  return r;
}, Pn = function(r, t) {
  return yt(On(vt(r), t));
}, Hr = /* @__PURE__ */ new WeakMap(), $n = function(r) {
  if (!(r.type !== "rule" || !r.parent || // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  r.length < 1)) {
    for (var t = r.value, o = r.parent, a = r.column === o.column && r.line === o.line; o.type !== "rule"; )
      if (o = o.parent, !o)
        return;
    if (!(r.props.length === 1 && t.charCodeAt(0) !== 58 && !Hr.get(o)) && !a) {
      Hr.set(r, !0);
      for (var i = [], s = Pn(t, i), f = o.props, d = 0, h = 0; d < s.length; d++)
        for (var p = 0; p < f.length; p++, h++)
          r.props[h] = i[d] ? s[d].replace(/&\f/g, f[p]) : f[p] + " " + s[d];
    }
  }
}, An = function(r) {
  if (r.type === "decl") {
    var t = r.value;
    // charcode for l
    t.charCodeAt(0) === 108 && // charcode for b
    t.charCodeAt(2) === 98 && (r.return = "", r.value = "");
  }
}, Nn = "emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason", kn = function(r) {
  return r.type === "comm" && r.children.indexOf(Nn) > -1;
}, In = function(r) {
  return function(t, o, a) {
    if (!(t.type !== "rule" || r.compat)) {
      var i = t.value.match(/(:first|:nth|:nth-last)-child/g);
      if (i) {
        for (var s = !!t.parent, f = s ? t.parent.children : (
          // global rule at the root level
          a
        ), d = f.length - 1; d >= 0; d--) {
          var h = f[d];
          if (h.line < t.line)
            break;
          if (h.column < t.column) {
            if (kn(h))
              return;
            break;
          }
        }
        i.forEach(function(p) {
          console.error('The pseudo class "' + p + '" is potentially unsafe when doing server-side rendering. Try changing it to "' + p.split("-child")[0] + '-of-type".');
        });
      }
    }
  };
}, mt = function(r) {
  return r.type.charCodeAt(1) === 105 && r.type.charCodeAt(0) === 64;
}, Dn = function(r, t) {
  for (var o = r - 1; o >= 0; o--)
    if (!mt(t[o]))
      return !0;
  return !1;
}, Jr = function(r) {
  r.type = "", r.value = "", r.return = "", r.children = "", r.props = "";
}, Fn = function(r, t, o) {
  mt(r) && (r.parent ? (console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles."), Jr(r)) : Dn(t, o) && (console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules."), Jr(r)));
};
function gt(e, r) {
  switch (dn(e, r)) {
    case 5103:
      return O + "print-" + e + e;
    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855:
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return O + e + e;
    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return O + e + Xe + e + W + e + e;
    case 6828:
    case 4268:
      return O + e + W + e + e;
    case 6165:
      return O + e + W + "flex-" + e + e;
    case 5187:
      return O + e + P(e, /(\w+).+(:[^]+)/, O + "box-$1$2" + W + "flex-$1$2") + e;
    case 5443:
      return O + e + W + "flex-item-" + P(e, /flex-|-self/, "") + e;
    case 4675:
      return O + e + W + "flex-line-pack" + P(e, /align-content|flex-|-self/, "") + e;
    case 5548:
      return O + e + W + P(e, "shrink", "negative") + e;
    case 5292:
      return O + e + W + P(e, "basis", "preferred-size") + e;
    case 6060:
      return O + "box-" + P(e, "-grow", "") + O + e + W + P(e, "grow", "positive") + e;
    case 4554:
      return O + P(e, /([^-])(transform)/g, "$1" + O + "$2") + e;
    case 6187:
      return P(P(P(e, /(zoom-|grab)/, O + "$1"), /(image-set)/, O + "$1"), e, "") + e;
    case 5495:
    case 3959:
      return P(e, /(image-set\([^]*)/, O + "$1$`$1");
    case 4968:
      return P(P(e, /(.+:)(flex-)?(.*)/, O + "box-pack:$3" + W + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + O + e + e;
    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return P(e, /(.+)-inline(.+)/, O + "$1$2") + e;
    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (re(e) - 1 - r > 6)
        switch (Y(e, r + 1)) {
          case 109:
            if (Y(e, r + 4) !== 45)
              break;
          case 102:
            return P(e, /(.+:)(.+)-([^]+)/, "$1" + O + "$2-$3$1" + Xe + (Y(e, r + 3) == 108 ? "$3" : "$2-$3")) + e;
          case 115:
            return ~yr(e, "stretch") ? gt(P(e, "stretch", "fill-available"), r) + e : e;
        }
      break;
    case 4949:
      if (Y(e, r + 1) !== 115)
        break;
    case 6444:
      switch (Y(e, re(e) - 3 - (~yr(e, "!important") && 10))) {
        case 107:
          return P(e, ":", ":" + O) + e;
        case 101:
          return P(e, /(.+:)([^;!]+)(;|!.+)?/, "$1" + O + (Y(e, 14) === 45 ? "inline-" : "") + "box$3$1" + O + "$2$3$1" + W + "$2box$3") + e;
      }
      break;
    case 5936:
      switch (Y(e, r + 11)) {
        case 114:
          return O + e + W + P(e, /[svh]\w+-[tblr]{2}/, "tb") + e;
        case 108:
          return O + e + W + P(e, /[svh]\w+-[tblr]{2}/, "tb-rl") + e;
        case 45:
          return O + e + W + P(e, /[svh]\w+-[tblr]{2}/, "lr") + e;
      }
      return O + e + W + e + e;
  }
  return e;
}
var Mn = function(r, t, o, a) {
  if (r.length > -1 && !r.return)
    switch (r.type) {
      case wr:
        r.return = gt(r.value, r.length);
        break;
      case dt:
        return xe([Ne(r, {
          value: P(r.value, "@", "@" + O)
        })], a);
      case Sr:
        if (r.length)
          return hn(r.props, function(i) {
            switch (pn(i, /(::plac\w+|:read-\w+)/)) {
              case ":read-only":
              case ":read-write":
                return xe([Ne(r, {
                  props: [P(i, /:(read-\w+)/, ":" + Xe + "$1")]
                })], a);
              case "::placeholder":
                return xe([Ne(r, {
                  props: [P(i, /:(plac\w+)/, ":" + O + "input-$1")]
                }), Ne(r, {
                  props: [P(i, /:(plac\w+)/, ":" + Xe + "$1")]
                }), Ne(r, {
                  props: [P(i, /:(plac\w+)/, W + "input-$1")]
                })], a);
            }
            return "";
          });
    }
}, jn = [Mn], Ln = function(r) {
  var t = r.key;
  if (process.env.NODE_ENV !== "production" && !t)
    throw new Error(`You have to configure \`key\` for your cache. Please make sure it's unique (and not equal to 'css') as it's used for linking styles to your cache.
If multiple caches share the same key they might "fight" for each other's style elements.`);
  if (t === "css") {
    var o = document.querySelectorAll("style[data-emotion]:not([data-s])");
    Array.prototype.forEach.call(o, function(m) {
      var k = m.getAttribute("data-emotion");
      k.indexOf(" ") !== -1 && (document.head.appendChild(m), m.setAttribute("data-s", ""));
    });
  }
  var a = r.stylisPlugins || jn;
  if (process.env.NODE_ENV !== "production" && /[^a-z-]/.test(t))
    throw new Error('Emotion key must only contain lower case alphabetical characters and - but "' + t + '" was passed');
  var i = {}, s, f = [];
  s = r.container || document.head, Array.prototype.forEach.call(
    // this means we will ignore elements which don't have a space in them which
    // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll('style[data-emotion^="' + t + ' "]'),
    function(m) {
      for (var k = m.getAttribute("data-emotion").split(" "), x = 1; x < k.length; x++)
        i[k[x]] = !0;
      f.push(m);
    }
  );
  var d, h = [$n, An];
  process.env.NODE_ENV !== "production" && h.push(In({
    get compat() {
      return C.compat;
    }
  }), Fn);
  {
    var p, v = [Cn, process.env.NODE_ENV !== "production" ? function(m) {
      m.root || (m.return ? p.insert(m.return) : m.value && m.type !== Cr && p.insert(m.value + "{}"));
    } : wn(function(m) {
      p.insert(m);
    })], b = Sn(h.concat(a, v)), _ = function(k) {
      return xe(xn(k), b);
    };
    d = function(k, x, E, $) {
      p = E, process.env.NODE_ENV !== "production" && x.map !== void 0 && (p = {
        insert: function(u) {
          E.insert(u + x.map);
        }
      }), _(k ? k + "{" + x.styles + "}" : x.styles), $ && (C.inserted[x.name] = !0);
    };
  }
  var C = {
    key: t,
    sheet: new sn({
      key: t,
      container: s,
      nonce: r.nonce,
      speedy: r.speedy,
      prepend: r.prepend,
      insertionPoint: r.insertionPoint
    }),
    nonce: r.nonce,
    inserted: i,
    registered: {},
    insert: d
  };
  return C.sheet.hydrate(f), C;
}, gr = { exports: {} }, A = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Kr;
function Vn() {
  if (Kr)
    return A;
  Kr = 1;
  var e = typeof Symbol == "function" && Symbol.for, r = e ? Symbol.for("react.element") : 60103, t = e ? Symbol.for("react.portal") : 60106, o = e ? Symbol.for("react.fragment") : 60107, a = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, s = e ? Symbol.for("react.provider") : 60109, f = e ? Symbol.for("react.context") : 60110, d = e ? Symbol.for("react.async_mode") : 60111, h = e ? Symbol.for("react.concurrent_mode") : 60111, p = e ? Symbol.for("react.forward_ref") : 60112, v = e ? Symbol.for("react.suspense") : 60113, b = e ? Symbol.for("react.suspense_list") : 60120, _ = e ? Symbol.for("react.memo") : 60115, C = e ? Symbol.for("react.lazy") : 60116, m = e ? Symbol.for("react.block") : 60121, k = e ? Symbol.for("react.fundamental") : 60117, x = e ? Symbol.for("react.responder") : 60118, E = e ? Symbol.for("react.scope") : 60119;
  function $(u) {
    if (typeof u == "object" && u !== null) {
      var F = u.$$typeof;
      switch (F) {
        case r:
          switch (u = u.type, u) {
            case d:
            case h:
            case o:
            case i:
            case a:
            case v:
              return u;
            default:
              switch (u = u && u.$$typeof, u) {
                case f:
                case p:
                case C:
                case _:
                case s:
                  return u;
                default:
                  return F;
              }
          }
        case t:
          return F;
      }
    }
  }
  function I(u) {
    return $(u) === h;
  }
  return A.AsyncMode = d, A.ConcurrentMode = h, A.ContextConsumer = f, A.ContextProvider = s, A.Element = r, A.ForwardRef = p, A.Fragment = o, A.Lazy = C, A.Memo = _, A.Portal = t, A.Profiler = i, A.StrictMode = a, A.Suspense = v, A.isAsyncMode = function(u) {
    return I(u) || $(u) === d;
  }, A.isConcurrentMode = I, A.isContextConsumer = function(u) {
    return $(u) === f;
  }, A.isContextProvider = function(u) {
    return $(u) === s;
  }, A.isElement = function(u) {
    return typeof u == "object" && u !== null && u.$$typeof === r;
  }, A.isForwardRef = function(u) {
    return $(u) === p;
  }, A.isFragment = function(u) {
    return $(u) === o;
  }, A.isLazy = function(u) {
    return $(u) === C;
  }, A.isMemo = function(u) {
    return $(u) === _;
  }, A.isPortal = function(u) {
    return $(u) === t;
  }, A.isProfiler = function(u) {
    return $(u) === i;
  }, A.isStrictMode = function(u) {
    return $(u) === a;
  }, A.isSuspense = function(u) {
    return $(u) === v;
  }, A.isValidElementType = function(u) {
    return typeof u == "string" || typeof u == "function" || u === o || u === h || u === i || u === a || u === v || u === b || typeof u == "object" && u !== null && (u.$$typeof === C || u.$$typeof === _ || u.$$typeof === s || u.$$typeof === f || u.$$typeof === p || u.$$typeof === k || u.$$typeof === x || u.$$typeof === E || u.$$typeof === m);
  }, A.typeOf = $, A;
}
var N = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Zr;
function Yn() {
  return Zr || (Zr = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, r = e ? Symbol.for("react.element") : 60103, t = e ? Symbol.for("react.portal") : 60106, o = e ? Symbol.for("react.fragment") : 60107, a = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, s = e ? Symbol.for("react.provider") : 60109, f = e ? Symbol.for("react.context") : 60110, d = e ? Symbol.for("react.async_mode") : 60111, h = e ? Symbol.for("react.concurrent_mode") : 60111, p = e ? Symbol.for("react.forward_ref") : 60112, v = e ? Symbol.for("react.suspense") : 60113, b = e ? Symbol.for("react.suspense_list") : 60120, _ = e ? Symbol.for("react.memo") : 60115, C = e ? Symbol.for("react.lazy") : 60116, m = e ? Symbol.for("react.block") : 60121, k = e ? Symbol.for("react.fundamental") : 60117, x = e ? Symbol.for("react.responder") : 60118, E = e ? Symbol.for("react.scope") : 60119;
    function $(y) {
      return typeof y == "string" || typeof y == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      y === o || y === h || y === i || y === a || y === v || y === b || typeof y == "object" && y !== null && (y.$$typeof === C || y.$$typeof === _ || y.$$typeof === s || y.$$typeof === f || y.$$typeof === p || y.$$typeof === k || y.$$typeof === x || y.$$typeof === E || y.$$typeof === m);
    }
    function I(y) {
      if (typeof y == "object" && y !== null) {
        var Oe = y.$$typeof;
        switch (Oe) {
          case r:
            var ge = y.type;
            switch (ge) {
              case d:
              case h:
              case o:
              case i:
              case a:
              case v:
                return ge;
              default:
                var ce = ge && ge.$$typeof;
                switch (ce) {
                  case f:
                  case p:
                  case C:
                  case _:
                  case s:
                    return ce;
                  default:
                    return Oe;
                }
            }
          case t:
            return Oe;
        }
      }
    }
    var u = d, F = h, T = f, fe = s, ue = r, le = p, Se = o, de = C, G = _, Z = t, ne = i, pe = a, he = v, ie = !1;
    function ve(y) {
      return ie || (ie = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), se(y) || I(y) === d;
    }
    function se(y) {
      return I(y) === h;
    }
    function Ve(y) {
      return I(y) === f;
    }
    function Ye(y) {
      return I(y) === s;
    }
    function We(y) {
      return typeof y == "object" && y !== null && y.$$typeof === r;
    }
    function ir(y) {
      return I(y) === p;
    }
    function sr(y) {
      return I(y) === o;
    }
    function we(y) {
      return I(y) === C;
    }
    function Te(y) {
      return I(y) === _;
    }
    function ye(y) {
      return I(y) === t;
    }
    function Re(y) {
      return I(y) === i;
    }
    function me(y) {
      return I(y) === a;
    }
    function cr(y) {
      return I(y) === v;
    }
    N.AsyncMode = u, N.ConcurrentMode = F, N.ContextConsumer = T, N.ContextProvider = fe, N.Element = ue, N.ForwardRef = le, N.Fragment = Se, N.Lazy = de, N.Memo = G, N.Portal = Z, N.Profiler = ne, N.StrictMode = pe, N.Suspense = he, N.isAsyncMode = ve, N.isConcurrentMode = se, N.isContextConsumer = Ve, N.isContextProvider = Ye, N.isElement = We, N.isForwardRef = ir, N.isFragment = sr, N.isLazy = we, N.isMemo = Te, N.isPortal = ye, N.isProfiler = Re, N.isStrictMode = me, N.isSuspense = cr, N.isValidElementType = $, N.typeOf = I;
  }()), N;
}
process.env.NODE_ENV === "production" ? gr.exports = Vn() : gr.exports = Yn();
var Wn = gr.exports, bt = Wn, zn = {
  $$typeof: !0,
  render: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0
}, Un = {
  $$typeof: !0,
  compare: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0,
  type: !0
}, Et = {};
Et[bt.ForwardRef] = zn;
Et[bt.Memo] = Un;
var Bn = !0;
function qn(e, r, t) {
  var o = "";
  return t.split(" ").forEach(function(a) {
    e[a] !== void 0 ? r.push(e[a] + ";") : o += a + " ";
  }), o;
}
var xt = function(r, t, o) {
  var a = r.key + "-" + t.name;
  // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (o === !1 || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  Bn === !1) && r.registered[a] === void 0 && (r.registered[a] = t.styles);
}, Gn = function(r, t, o) {
  xt(r, t, o);
  var a = r.key + "-" + t.name;
  if (r.inserted[t.name] === void 0) {
    var i = t;
    do
      r.insert(t === i ? "." + a : "", i, r.sheet, !0), i = i.next;
    while (i !== void 0);
  }
};
function Hn(e) {
  for (var r = 0, t, o = 0, a = e.length; a >= 4; ++o, a -= 4)
    t = e.charCodeAt(o) & 255 | (e.charCodeAt(++o) & 255) << 8 | (e.charCodeAt(++o) & 255) << 16 | (e.charCodeAt(++o) & 255) << 24, t = /* Math.imul(k, m): */
    (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16), t ^= /* k >>> r: */
    t >>> 24, r = /* Math.imul(k, m): */
    (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16) ^ /* Math.imul(h, m): */
    (r & 65535) * 1540483477 + ((r >>> 16) * 59797 << 16);
  switch (a) {
    case 3:
      r ^= (e.charCodeAt(o + 2) & 255) << 16;
    case 2:
      r ^= (e.charCodeAt(o + 1) & 255) << 8;
    case 1:
      r ^= e.charCodeAt(o) & 255, r = /* Math.imul(h, m): */
      (r & 65535) * 1540483477 + ((r >>> 16) * 59797 << 16);
  }
  return r ^= r >>> 13, r = /* Math.imul(h, m): */
  (r & 65535) * 1540483477 + ((r >>> 16) * 59797 << 16), ((r ^ r >>> 15) >>> 0).toString(36);
}
var Jn = {
  animationIterationCount: 1,
  aspectRatio: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
}, Xr = `You have illegal escape sequence in your template literal, most likely inside content's property value.
Because you write your CSS inside a JavaScript string you actually have to do double escaping, so for example "content: '\\00d7';" should become "content: '\\\\00d7';".
You can read more about this here:
https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences`, Kn = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).", Zn = /[A-Z]|^ms/g, _t = /_EMO_([^_]+?)_([^]*?)_EMO_/g, Rr = function(r) {
  return r.charCodeAt(1) === 45;
}, Qr = function(r) {
  return r != null && typeof r != "boolean";
}, hr = /* @__PURE__ */ Tn(function(e) {
  return Rr(e) ? e : e.replace(Zn, "-$&").toLowerCase();
}), Qe = function(r, t) {
  switch (r) {
    case "animation":
    case "animationName":
      if (typeof t == "string")
        return t.replace(_t, function(o, a, i) {
          return X = {
            name: a,
            styles: i,
            next: X
          }, a;
        });
  }
  return Jn[r] !== 1 && !Rr(r) && typeof t == "number" && t !== 0 ? t + "px" : t;
};
if (process.env.NODE_ENV !== "production") {
  var Xn = /(var|attr|counters?|url|element|(((repeating-)?(linear|radial))|conic)-gradient)\(|(no-)?(open|close)-quote/, Qn = ["normal", "none", "initial", "inherit", "unset"], eo = Qe, ro = /^-ms-/, to = /-(.)/g, et = {};
  Qe = function(r, t) {
    if (r === "content" && (typeof t != "string" || Qn.indexOf(t) === -1 && !Xn.test(t) && (t.charAt(0) !== t.charAt(t.length - 1) || t.charAt(0) !== '"' && t.charAt(0) !== "'")))
      throw new Error("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"" + t + "\"'`");
    var o = eo(r, t);
    return o !== "" && !Rr(r) && r.indexOf("-") !== -1 && et[r] === void 0 && (et[r] = !0, console.error("Using kebab-case for css properties in objects is not supported. Did you mean " + r.replace(ro, "ms-").replace(to, function(a, i) {
      return i.toUpperCase();
    }) + "?")), o;
  };
}
var Ct = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function De(e, r, t) {
  if (t == null)
    return "";
  if (t.__emotion_styles !== void 0) {
    if (process.env.NODE_ENV !== "production" && t.toString() === "NO_COMPONENT_SELECTOR")
      throw new Error(Ct);
    return t;
  }
  switch (typeof t) {
    case "boolean":
      return "";
    case "object": {
      if (t.anim === 1)
        return X = {
          name: t.name,
          styles: t.styles,
          next: X
        }, t.name;
      if (t.styles !== void 0) {
        var o = t.next;
        if (o !== void 0)
          for (; o !== void 0; )
            X = {
              name: o.name,
              styles: o.styles,
              next: X
            }, o = o.next;
        var a = t.styles + ";";
        return process.env.NODE_ENV !== "production" && t.map !== void 0 && (a += t.map), a;
      }
      return no(e, r, t);
    }
    case "function": {
      if (e !== void 0) {
        var i = X, s = t(e);
        return X = i, De(e, r, s);
      } else
        process.env.NODE_ENV !== "production" && console.error("Functions that are interpolated in css calls will be stringified.\nIf you want to have a css call based on props, create a function that returns a css call like this\nlet dynamicStyle = (props) => css`color: ${props.color}`\nIt can be called directly with props or interpolated in a styled call like this\nlet SomeComponent = styled('div')`${dynamicStyle}`");
      break;
    }
    case "string":
      if (process.env.NODE_ENV !== "production") {
        var f = [], d = t.replace(_t, function(p, v, b) {
          var _ = "animation" + f.length;
          return f.push("const " + _ + " = keyframes`" + b.replace(/^@keyframes animation-\w+/, "") + "`"), "${" + _ + "}";
        });
        f.length && console.error("`keyframes` output got interpolated into plain string, please wrap it with `css`.\n\nInstead of doing this:\n\n" + [].concat(f, ["`" + d + "`"]).join(`
`) + `

You should wrap it with \`css\` like this:

` + ("css`" + d + "`"));
      }
      break;
  }
  if (r == null)
    return t;
  var h = r[t];
  return h !== void 0 ? h : t;
}
function no(e, r, t) {
  var o = "";
  if (Array.isArray(t))
    for (var a = 0; a < t.length; a++)
      o += De(e, r, t[a]) + ";";
  else
    for (var i in t) {
      var s = t[i];
      if (typeof s != "object")
        r != null && r[s] !== void 0 ? o += i + "{" + r[s] + "}" : Qr(s) && (o += hr(i) + ":" + Qe(i, s) + ";");
      else {
        if (i === "NO_COMPONENT_SELECTOR" && process.env.NODE_ENV !== "production")
          throw new Error(Ct);
        if (Array.isArray(s) && typeof s[0] == "string" && (r == null || r[s[0]] === void 0))
          for (var f = 0; f < s.length; f++)
            Qr(s[f]) && (o += hr(i) + ":" + Qe(i, s[f]) + ";");
        else {
          var d = De(e, r, s);
          switch (i) {
            case "animation":
            case "animationName": {
              o += hr(i) + ":" + d + ";";
              break;
            }
            default:
              process.env.NODE_ENV !== "production" && i === "undefined" && console.error(Kn), o += i + "{" + d + "}";
          }
        }
      }
    }
  return o;
}
var rt = /label:\s*([^\s;\n{]+)\s*(;|$)/g, St;
process.env.NODE_ENV !== "production" && (St = /\/\*#\ssourceMappingURL=data:application\/json;\S+\s+\*\//g);
var X, tt = function(r, t, o) {
  if (r.length === 1 && typeof r[0] == "object" && r[0] !== null && r[0].styles !== void 0)
    return r[0];
  var a = !0, i = "";
  X = void 0;
  var s = r[0];
  s == null || s.raw === void 0 ? (a = !1, i += De(o, t, s)) : (process.env.NODE_ENV !== "production" && s[0] === void 0 && console.error(Xr), i += s[0]);
  for (var f = 1; f < r.length; f++)
    i += De(o, t, r[f]), a && (process.env.NODE_ENV !== "production" && s[f] === void 0 && console.error(Xr), i += s[f]);
  var d;
  process.env.NODE_ENV !== "production" && (i = i.replace(St, function(b) {
    return d = b, "";
  })), rt.lastIndex = 0;
  for (var h = "", p; (p = rt.exec(i)) !== null; )
    h += "-" + // $FlowFixMe we know it's not null
    p[1];
  var v = Hn(i) + h;
  return process.env.NODE_ENV !== "production" ? {
    name: v,
    styles: i,
    map: d,
    next: X,
    toString: function() {
      return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
  } : {
    name: v,
    styles: i,
    next: X
  };
}, oo = function(r) {
  return r();
}, ao = ae["useInsertionEffect"] ? ae["useInsertionEffect"] : !1, io = ao || oo, ar = {}.hasOwnProperty, Or = /* @__PURE__ */ ae.createContext(
  // we're doing this to avoid preconstruct's dead code elimination in this one case
  // because this module is primarily intended for the browser and node
  // but it's also required in react native and similar environments sometimes
  // and we could have a special build just for that
  // but this is much easier and the native packages
  // might use a different theme context in the future anyway
  typeof HTMLElement < "u" ? /* @__PURE__ */ Ln({
    key: "css"
  }) : null
);
process.env.NODE_ENV !== "production" && (Or.displayName = "EmotionCacheContext");
Or.Provider;
var so = function(r) {
  return /* @__PURE__ */ Fe(function(t, o) {
    var a = ct(Or);
    return r(t, a, o);
  });
}, wt = /* @__PURE__ */ ae.createContext({});
process.env.NODE_ENV !== "production" && (wt.displayName = "EmotionThemeContext");
var nt = function(r) {
  var t = r.split(".");
  return t[t.length - 1];
}, co = function(r) {
  var t = /^\s+at\s+([A-Za-z0-9$.]+)\s/.exec(r);
  if (t || (t = /^([A-Za-z0-9$.]+)@/.exec(r), t))
    return nt(t[1]);
}, fo = /* @__PURE__ */ new Set(["renderWithHooks", "processChild", "finishClassComponent", "renderToString"]), uo = function(r) {
  return r.replace(/\$/g, "-");
}, lo = function(r) {
  if (r)
    for (var t = r.split(`
`), o = 0; o < t.length; o++) {
      var a = co(t[o]);
      if (a) {
        if (fo.has(a))
          break;
        if (/^[A-Z]/.test(a))
          return uo(a);
      }
    }
}, br = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__", Er = "__EMOTION_LABEL_PLEASE_DO_NOT_USE__", Tt = function(r, t) {
  if (process.env.NODE_ENV !== "production" && typeof t.css == "string" && // check if there is a css declaration
  t.css.indexOf(":") !== -1)
    throw new Error("Strings are not allowed as css prop values, please wrap it in a css template literal from '@emotion/react' like this: css`" + t.css + "`");
  var o = {};
  for (var a in t)
    ar.call(t, a) && (o[a] = t[a]);
  if (o[br] = r, process.env.NODE_ENV !== "production" && t.css && (typeof t.css != "object" || typeof t.css.name != "string" || t.css.name.indexOf("-") === -1)) {
    var i = lo(new Error().stack);
    i && (o[Er] = i);
  }
  return o;
}, po = function(r) {
  var t = r.cache, o = r.serialized, a = r.isStringTag;
  return xt(t, o, a), io(function() {
    return Gn(t, o, a);
  }), null;
}, Rt = /* @__PURE__ */ so(function(e, r, t) {
  var o = e.css;
  typeof o == "string" && r.registered[o] !== void 0 && (o = r.registered[o]);
  var a = e[br], i = [o], s = "";
  typeof e.className == "string" ? s = qn(r.registered, i, e.className) : e.className != null && (s = e.className + " ");
  var f = tt(i, void 0, ae.useContext(wt));
  if (process.env.NODE_ENV !== "production" && f.name.indexOf("-") === -1) {
    var d = e[Er];
    d && (f = tt([f, "label:" + d + ";"]));
  }
  s += r.key + "-" + f.name;
  var h = {};
  for (var p in e)
    ar.call(e, p) && p !== "css" && p !== br && (process.env.NODE_ENV === "production" || p !== Er) && (h[p] = e[p]);
  return h.ref = t, h.className = s, /* @__PURE__ */ ae.createElement(ae.Fragment, null, /* @__PURE__ */ ae.createElement(po, {
    cache: r,
    serialized: f,
    isStringTag: typeof a == "string"
  }), /* @__PURE__ */ ae.createElement(a, h));
});
process.env.NODE_ENV !== "production" && (Rt.displayName = "EmotionCssPropInternal");
var Ot = Rt;
function V(e, r, t) {
  return ar.call(r, "css") ? Ze.jsx(Ot, Tt(e, r), t) : Ze.jsx(e, r, t);
}
function Ge(e, r, t) {
  return ar.call(r, "css") ? Ze.jsxs(Ot, Tt(e, r), t) : Ze.jsxs(e, r, t);
}
class ho {
  constructor() {
    B(this, "expandable", !0);
    B(this, "rows", 2);
    B(this, "suffix", null);
    B(this, "expandLabel");
    B(this, "tooltip", !0);
    B(this, "onExpand");
  }
}
class ot {
  constructor() {
    B(this, "config", new ho());
  }
  expandable(r) {
    return this.config.expandable = r, this;
  }
  rows(r) {
    return this.config.rows = r, this;
  }
  suffix(r) {
    return this.config.suffix = r, this;
  }
  expandLabel(r) {
    return this.config.expandLabel = r, this;
  }
  tooltip(r) {
    return this.config.tooltip = r, this;
  }
  onExpand(r) {
    return this.config.onExpand = r, this;
  }
  create() {
    return this.config;
  }
}
const Pt = [
  "white",
  "blackAlpha",
  "gray",
  "grayBlue",
  "red",
  "orange",
  "yellow",
  "green",
  "blue",
  "cyan",
  "purple"
], vo = z`
  display: inline-block;
`;
z`
  display: inline-flex;
  flex-direction: row;
  align-items: center;
`;
function yo(e) {
  const r = Pt.includes(e) ? Q(`--${ee}-${e}-02`) : e;
  return z`
    color: ${r};
  `;
}
function mo(e, r, t, o, a, i) {
  let s = z``;
  if (i && (s = z`
      ${s};
      background-color: ${Q(`--${ee}-grayBlue-05`)};
    `), e && (s = z`
      ${s};
      font-weight: bold;
    `), r && typeof r != "string" && (s = z`
      ${s};
      background-color: ${Q(`--${ee}-yellow-06`)};
    `), typeof r == "string") {
    const f = Pt.includes(r) ? Q(`--${ee}-${r}-06`) : r;
    s = z`
      ${s};
      background-color: ${f};
    `;
  }
  return s = z`
    ${s};
    text-decoration: ${t && "underline"} ${o && "line-through"};
  `, a && (s = z`
      ${s};
      cursor: not-allowed;
      color: ${Q(`--${ee}-grayBlue-05`)};
      user-select: none;
    `), s;
}
function go() {
  return z`
    cursor: pointer;
    margin: 0 4px;
    text-decoration: none;
    color: ${Q(`--${ee}-blue-03`)};
  `;
}
const bo = z`
  cursor: pointer;
  font-size: 0.75em;
  margin-left: 4px;
  color: ${Q(`--${ee}-grayBlue-02`)};
  display: inline-flex;
  align-items: center;
`;
function at(e, r, t, o) {
  var s;
  const a = e.getClientRects().length;
  return a > o ? !1 : a < o ? !0 : (((s = e.getClientRects()[o - 1]) == null ? void 0 : s.width) ?? 0) <= t;
}
function xr(e, r, t, o, a, i, s = 0, f = t.length) {
  if (s >= f - 1 && at(e, o, a, i))
    return;
  const d = Math.floor((s + f) / 2);
  r.textContent = t.slice(0, d).trim(), at(e, o, a, i) ? xr(e, r, t, o, a, i, d, f) : xr(e, r, t, o, a, i, s, d);
}
function Eo(e) {
  let r = 0;
  for (let t of e.getClientRects())
    r += t.height;
  return r;
}
function xo(e) {
  let r = 0;
  const t = e.getClientRects();
  for (let o = 0; o < t.length; o++)
    r += t[o].width;
  return r;
}
function _o(e) {
  return e.getBoundingClientRect().width;
}
function Co(e, r, t, o) {
  var m;
  const a = ((m = e.getClientRects()[0]) == null ? void 0 : m.height) ?? 0, i = xo(r);
  let s = document.createElement(e.tagName);
  document.body.appendChild(s);
  const f = je(Me.toArray(o)), d = document.createTextNode(f), h = window.getComputedStyle(e), v = Array.prototype.slice.apply(h).map((k) => `${k}: ${h.getPropertyValue(k)};`).join("");
  s.setAttribute("style", v), s.insertBefore(d, s.firstChild);
  const b = a * t;
  if (Eo(s) <= b)
    return s.remove(), {
      screenString: f,
      isClip: !1
    };
  const _ = _o(s) - i;
  xr(s, d, f, b, _, t);
  const C = s.textContent ?? "";
  return s.remove(), {
    fullText: f,
    screenString: C,
    isClip: !0
  };
}
class So {
  constructor() {
    B(this, "copyIcon", V(ft, { color: Q(`--${ee}-grayBlue-01`) }));
    B(this, "copiedIcon", V(ut, { color: Q(`--${ee}-green-03`) }));
    B(this, "copiedToolTip");
    B(this, "copyToolTip");
    B(this, "onCopy");
  }
}
class it {
  constructor() {
    B(this, "config", new So());
  }
  copyIcon(r) {
    return this.config.copyIcon = r, this;
  }
  copiedIcon(r) {
    return this.config.copiedIcon = r, this;
  }
  copiedTooltip(r) {
    return this.config.copiedToolTip = r, this;
  }
  copyTooltip(r) {
    return this.config.copyToolTip = r, this;
  }
  onCopy(r) {
    return this.config.onCopy = r, this;
  }
  create() {
    return this.config;
  }
}
function wo(e, r) {
  var a;
  let t;
  typeof r == "boolean" && r ? t = new ot().create() : typeof r == "boolean" && !r || r == null ? t = new ot().expandable(!1).tooltip(!1).create() : t = r;
  const o = ((a = e.locale) == null ? void 0 : a.typography) ?? lt.typography;
  return t.expandLabel == null && (t.expandLabel = o.expandLabel), t.rows == null && (t.rows = 2), t;
}
function To(e, r) {
  var a;
  let t;
  typeof r == "boolean" && r ? t = new it().create() : typeof r == "boolean" && !r || r == null ? t = new it().copyIcon(null).copiedIcon(null).create() : t = r;
  const o = ((a = e.locale) == null ? void 0 : a.typography) ?? lt.typography;
  return t.copyToolTip == null && (t.copyToolTip = o.copyToolTip), t.copiedToolTip == null && (t.copiedToolTip = o.copiedToolTip), t.copyIcon == null && (t.copyIcon = V(ft, { color: Q(`--${ee}-grayBlue-01`) })), t.copiedIcon == null && (t.copiedIcon = V(ut, { color: Q(`--${ee}-green-03`) })), t;
}
function Ro(e) {
  navigator.clipboard.writeText(e).then();
}
const Pr = (e) => {
  const { colorScheme: r = "gray", ellipsis: t, bold: o, disabled: a, mark: i, underline: s, deleted: f, code: d, copyable: h } = e;
  let p = ct(en), v = wo(p, t), b = To(p, h);
  const [_, C] = Be(v.expandable), [m, k] = Be(!1), x = v.expandable && _, [E, $] = Be(""), [I, u] = Be(!1), F = zr(), T = zr(), fe = z`
    ${yo(r)};
    ${mo(o, i, s, f, a, d)};
  `, ue = V("span", { ref: F, css: fe, children: x ? E : e.children }), le = V("span", { onClick: () => {
    u(!0), Ro(je(Me.toArray(e.children))), b.onCopy != null && b.onCopy();
  }, css: bo, children: I ? b.copiedIcon : b.copyIcon }), Se = I ? b.copiedToolTip : b.copyToolTip, de = x && !m && Ge(Xt, { children: [Ge("span", { css: fe, children: ["...", v.suffix && V("span", { children: v.suffix })] }), V("a", { css: go(), onClick: () => {
    v.onExpand != null && v.onExpand(), C(!1);
  }, children: v.expandLabel })] }), G = h && b.copyIcon && Se ? V(rr, { closeOnClick: !1, content: I ? b.copiedToolTip : b.copyToolTip, children: le }) : le, Z = (_ || h) && Ge("span", { ref: T, css: vo, children: [de, G] }), [ne, { width: pe }] = rn({ polyfill: ResizeObserver }), he = Ge("span", { ref: ne, children: [ue, Z] });
  return Qt(() => {
    let ie = !0;
    if (x) {
      const { screenString: ve, isClip: se } = Co(F.current, T.current, v.rows, e.children);
      ie && ($(ve), k(!se));
    }
    return () => {
      ie = !1;
    };
  }, [pe, x, v.rows, e.children]), he;
}, Oo = Fe((e, r) => {
  const { colorScheme: t = "blackAlpha", ellipsis: o, bold: a, disabled: i, mark: s, underline: f, deleted: d, code: h, copyable: p, fs: v = "14px", ...b } = e, _ = !i && (o == !0 || typeof o == "object" && o.tooltip), C = V(Pr, { colorScheme: t, ellipsis: o, bold: a, disabled: i, mark: s, underline: f, deleted: d, code: h, copyable: p, children: e.children }), m = V("div", { css: [_r(e)], ref: r, ...er(b), children: C });
  return _ ? V(rr, { content: je(Me.toArray(e.children)), children: m }) : m;
});
Oo.displayName = "Text";
const Po = Fe((e, r) => {
  const { colorScheme: t = "blackAlpha", level: o = "h2", ellipsis: a, bold: i, disabled: s, mark: f, underline: d, deleted: h, code: p, copyable: v, ...b } = e, _ = !s && (a == !0 || typeof a == "object" && a.tooltip), C = V(Pr, { colorScheme: t, ellipsis: a, bold: i, disabled: s, mark: f, underline: d, deleted: h, code: p, copyable: v, children: e.children });
  let k = V(o, { css: _r(e), ref: r, ...er(b), children: C });
  return _ ? V(rr, { content: je(Me.toArray(e.children)), children: k }) : k;
});
Po.displayName = "Heading";
function $o(e) {
  return e ? z`
      text-indent: 2em;
    ` : z``;
}
const Ao = Fe((e, r) => {
  const { colorScheme: t = "blackAlpha", ellipsis: o, bold: a, disabled: i, mark: s, underline: f, deleted: d, code: h, copyable: p, fs: v = "14px", indent: b, ..._ } = e, C = !i && (o == !0 || typeof o == "object" && o.tooltip), m = V("div", { css: [$o(b ?? !1), _r(e)], ref: r, ...er(_), children: V(Pr, { colorScheme: t, ellipsis: o, bold: a, disabled: i, mark: s, underline: f, deleted: d, code: h, copyable: p, children: e.children }) });
  return C ? V(rr, { content: je(Me.toArray(e.children)), children: m }) : m;
});
Ao.displayName = "Paragraph";
function K(e) {
  switch (e) {
    case "h1":
      return ["36px", "normal"];
    case "h2":
      return ["32px", "normal"];
    case "h3":
      return ["28px", "normal"];
    case "h4":
      return ["24px", "normal"];
    case "h5":
      return ["20px", "normal"];
    case "h6":
      return ["16px", "normal"];
  }
}
function No() {
  return z`
    word-break: break-all;

    h1 {
      margin: 0;
      font-size: ${K("h1")[0]};
      line-height: ${K("h1")[1]};
    }

    h2 {
      margin: 0;
      font-size: ${K("h2")[0]};
      line-height: ${K("h2")[1]};
    }

    h3 {
      margin: 0;
      font-size: ${K("h3")[0]};
      line-height: ${K("h3")[1]};
    }

    h4 {
      margin: 0;
      font-size: ${K("h4")[0]};
      line-height: ${K("h4")[1]};
    }

    h5 {
      margin: 0;
      font-size: ${K("h5")[0]};
      line-height: ${K("h5")[1]};
    }

    h6 {
      margin: 0;
      font-size: ${K("h6")[0]};
      line-height: ${K("h6")[1]};
    }

    p {
      margin: 0;
    }
  `;
}
const ko = Fe((e, r) => V("article", { css: [No()], ref: r, ...er(e), children: e.children }));
ko.displayName = "Typography";
export {
  So as Copyable,
  it as CopyableBuilder,
  ho as Ellipsis,
  ot as EllipsisBuilder,
  Po as Heading,
  Ao as Paragraph,
  Oo as Text,
  ko as Typography
};
//# sourceMappingURL=index.js.map
